<template>
  <div id="app">
    <v-app id="inspire">
      <template v-if="loading">
        <v-container align-center justify-center fill-height fluid wrap>
          <breeding-rhombus-spinner :animation-duration="2000" :size="65" color="blue"/>
        </v-container>
      </template>
      <template v-else>
        <v-container
          class="background-cont"
          align-content-space-around
          justify-center
          fill-height
          fluid
          grid-list-xl
        >
          <v-layout
            class="background-cont"
            align-space-around
            justify-space-around
            column
            fill-height
          >
            <v-flex offset-xs10>
              <v-img src="/idmlogo.png" height="70px" contain></v-img>
            </v-flex>
            <v-flex xs12>
              <v-card flat class="white--text">
                <h4
                  class="animated fadeInLeft font-title text-xs-center font-weight-black"
                >DISC TEST</h4>
                <h4
                  class="animated fadeInRight font-subtitle text-xs-center font-weight-bold"
                >Career Indomaret Group</h4>
                <h4
                  class="animated fadeInUp delay-1s font-subheading text-xs-center"
                >Pada tes ini anda diminta untuk menilai diri Anda sendiri. Oleh karena itu tidak ada jawaban benar/salah, semua jawaban benar asalkan sesuai dengan diri Anda!</h4>
                <v-card-text class="animated flash click text-xs-center">
                  Anda Pelamar? Klik!
                  <v-icon large dark color="rgb(251, 255, 16)">arrow_drop_down</v-icon>
                </v-card-text>
                <v-flex xs12 text-md-center text-sm-center text-xs-center>
                  <v-dialog v-model="dialog" persistent max-width="400px">
                    <v-btn
                      class="animated rotateIn"
                      slot="activator"
                      depressed
                      light
                      color="rgb(247, 6, 6)"
                      round
                    >
                      <v-icon light>assignment_ind</v-icon>&nbsp;
                      Mulai
                    </v-btn>
                    <v-stepper :color="color" v-model="el" alt-labels>
                      <v-stepper-header>
                        <v-stepper-step color="blue" :complete="el > 1" step="1">Password Akses</v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step color="blue" :complete="el > 2" step="2">Data Diri</v-stepper-step>
                      </v-stepper-header>
                      <v-stepper-items>
                        <v-stepper-content step="1">
                          <v-card flat>
                            <v-card-text>
                              <v-text-field
                                v-model="access_token"
                                label="Password Akses"
                                outline
                                :append-icon="showPassToken ? 'visibility' : 'visibility_off'"
                                :type="showPassToken ? 'text' : 'password'"
                                @click:append="showPassToken = !showPassToken"
                                autofocus
                                :color="color"
                                prepend-inner-icon="lock"
                                required
                                @keypress.enter="validateAccess"
                              >
                                <template v-if="loading_token" v-slot:append>
                                  <v-fade-transition leave-absolute>
                                    <v-progress-circular size="24" color="info" indeterminate></v-progress-circular>
                                  </v-fade-transition>
                                </template>
                              </v-text-field>
                            </v-card-text>
                          </v-card>

                          <v-card-actions>
                            <v-btn
                              depressed
                              round
                              small
                              :color="color"
                              @click="dialog = false"
                            >close</v-btn>
                            <v-spacer/>
                            <v-btn
                              depressed
                              round
                              small
                              :color="color"
                              :disabled="access_token === '' || loading_token"
                              @click="validateAccess"
                            >next</v-btn>
                          </v-card-actions>
                        </v-stepper-content>
                        <v-stepper-content step="2">
                          <v-card width="100%" height="100%">
                            <v-card-text>
                              <v-form ref="form" v-model="valid" lazy-validation>
                                <v-text-field
                                  v-model="name"
                                  :color="color"
                                  :rules="nameRules"
                                  label="Nama Lengkap"
                                  required
                                  prepend-inner-icon="person"
                                  autofocus
                                  outline
                                ></v-text-field>
                                <v-text-field
                                  mask="################"
                                  v-model="id_number"
                                  :rules="idRules"
                                  label="Nomor KTP"
                                  :color="color"
                                  prepend-inner-icon="featured_play_list"
                                  counter
                                  outline
                                  required
                                  loading
                                >
                                  <v-progress-linear
                                    slot="progress"
                                    :value="progress"
                                    :color="colorProg"
                                    height="2"
                                  />
                                </v-text-field>

                                <!-- <v-divider/> -->
                                <hr>

                                <span
                                  class="grey--text font-weight-regular text--darken-1"
                                >Jenis Kelamin</span>
                                <v-radio-group
                                  style="margin-top:2px !important"
                                  row
                                  v-model="gender"
                                  :rules="genderRules"
                                  :mandatory="false"
                                  required
                                  :color="color"
                                >
                                  <v-radio label="Laki-laki" value="Laki-laki"></v-radio>
                                  <v-radio label="Perempuan" value="Perempuan"></v-radio>
                                </v-radio-group>

                                <v-menu
                                  ref="menu"
                                  v-model="menu"
                                  :close-on-content-click="false"
                                  lazy
                                  transition="scale-transition"
                                  offset-y
                                  full-width
                                  max-width="290px"
                                  min-width="290px"
                                >
                                  <v-text-field
                                    outline
                                    slot="activator"
                                    v-model="birthday_date"
                                    :rules="dateRules"
                                    label="Tanggal Lahir"
                                    prepend-inner-icon="event"
                                    :color="color"
                                    required
                                    readonly
                                  ></v-text-field>
                                  <v-date-picker
                                    dark
                                    scrollable
                                    locale="id"
                                    :color="color"
                                    no-title
                                    v-model="birthday_date"
                                    @input="menu = false"
                                  ></v-date-picker>
                                </v-menu>
                              </v-form>
                            </v-card-text>

                            <v-card-actions>
                              <v-btn small depressed round :color="color" @click="close">close</v-btn>

                              <v-spacer></v-spacer>

                              <v-btn
                                :color="color"
                                depressed
                                round
                                small
                                :disabled="!valid || loading"
                                @click="submit"
                              >submit</v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-stepper-content>
                      </v-stepper-items>
                    </v-stepper>
                  </v-dialog>
                </v-flex>
              </v-card>
            </v-flex>
            <v-flex class="footer">
              <!-- <span>
                &copy;2019 —
                <a target="_blank" href="https://career.indomaretgroup.com/registrasi/">
                  <strong>CareerIndomaretGroup</strong>
                </a>
              </span>-->

              <v-card color="#212121" dark height="auto">
                <v-card flat tile class="text-xs-center">
                  <v-btn
                    small
                    v-for="item in icons"
                    :key="item.id"
                    class="mx-3 my-0 py-1"
                    icon
                    :href="item.link"
                    target="_blank"
                  >
                    <v-icon small dark>{{ item.icon }}</v-icon>
                  </v-btn>
                  <!-- </v-card-text> -->

                  <v-card-text class="pt-1 text-xs-center">
                    <span>
                      <strong>PT. INDOMARCO PRISMATAMA</strong>
                    </span>
                    <br>
                    <span>Head Office I : Jl. Ancol 1 No. 9-10, Ancol Barat - Pademangan, Jakarta Utara 14430. Ph. (021) 6909400</span>
                    <br>
                    <span>Head Office II : Jl. Terusan Angkasa, B2 Kav. 1, Gunung Sahari Selatan, Kemayoran, Jakarta Pusat 10610. Ph. (021) 29559100</span>
                  </v-card-text>

                  <v-divider/>
                  <!-- <v-spacer/> -->

                  <v-card-text class="px-1 py-1">
                    Copyright &copy;2019 —
                    <a
                      style="color: white !important"
                      target="_blank"
                      href="https://career.indomaretgroup.com/registrasi/"
                    >
                      <strong>CareerIndomaretGroup</strong>
                    </a>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </v-app>
  </div>
</template>

<style>
.font-title,
.font-subheading,
.font-subtitle,
.click {
  font-family: "Product Sans" !important;
  color: white;
}

.font-title {
  font-size: 50px !important;
  letter-spacing: 0.05em;
}

.font-subtitle {
  font-size: 25px !important;
  letter-spacing: 0.2em;
}

.font-subheading {
  font-size: 15px !important;
  letter-spacing: 0.1em;
  font-style: italic;
}

.background-cont {
  background: #005cb9;
  padding: 0 !important;
  margin: 0 !important;
  /* background: linear-gradient(52deg, #ffc629 0%, #005cb9 50%, #cf3339 100%); */
}

.click {
  font-size: 11px !important;
  letter-spacing: 0.2em;
  color: rgb(251, 255, 0);
  animation-duration: 2s;
  animation-delay: 2s;
  animation-iteration-count: infinite;
  padding: 0;
  white-space: pre-line;
}

.footer {
  font-size: 12px !important;
  padding: 0 !important;
  letter-spacing: 0.02em;
}

a:hover {
  text-decoration: underline;
}

a:active {
  text-decoration: underline;
}
</style>

<script>
import { mapActions, mapMutations } from "vuex";
import { BreedingRhombusSpinner } from "epic-spinners";

export default {
  name: "c-home",

  components: {
    BreedingRhombusSpinner
  },

  data() {
    return {
      dialog: false,
      menu: false,
      valid: false,
      loading: false,
      color: "blue",

      loading_token: false,
      el: 1,
      showPassToken: false,

      access_token: "",
      name: "",
      id_number: "",
      gender: "",
      birthday_date: "",
      nameRules: [v => !!v || "Nama harus diisi"],
      idRules: [
        v => !!v || "No. KTP harus diisi",
        v => (v && v.length == 16) || "No. KTP harus 16 karakter"
      ],
      genderRules: [v => !!v || "Jenis Kelamin harus dipilih"],
      dateRules: [v => !!v || "Tanggal Lahir harus diisi"],

      icons: [
        {
          icon: "fab fa-facebook",
          link: "https://www.facebook.com/indomaretgroup/"
        },
        { icon: "fab fa-twitter", link: "https://twitter.com/career_idmgroup" },
        {
          icon: "fab fa-linkedin",
          link: "https://www.linkedin.com/company/career-indomaret-group/"
        },
        {
          icon: "fab fa-instagram",
          link: "https://www.instagram.com/career_idmgroup/"
        }
      ]
    };
  },

  methods: {
    ...mapActions({
      setApplicant: "setApplicant"
    }),

    clear() {
      (this.name = ""),
        (this.id_number = ""),
        (this.gender = ""),
        (this.birthday_date = "");
      (this.valid = true)((this.custom = true));
      // this.$refs.form.resetValidation();
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        let formData = new FormData();

        formData.set("token_test", this.access_token);
        formData.set("id_number", this.id_number);
        formData.set("name", this.name);
        formData.set("gender", this.gender);
        formData.set("birthday_date", this.birthday_date);

        this.$store
          .dispatch("setApplicant", formData)
          .then(response => {
            Bus.$emit("setApplicant", response);
            this.loading = false;
            this.$router.push("/test");
          })
          .catch(error => {
            if (error.response.status == 422) {
              let errorMessages = '';

              for (let field in error.response.data.message) {
                for (let message of error.response.data.message[field]) {
                  errorMessages += `<li>${message}</li>`;
                }
              }

              this.$toast.error({
                title: "Error",
                message: `<ul>${errorMessages}</ul>`,
                useHtml: true
              });
            } else if (error.response.status == 500) {
              this.$toast.error({
                title: "Error",
                message: "Terjadi kesalahan dalam server!"
              });
            }

            this.loading = false;
            this.dialog = false;
            this.access_token = "";
            this.el = 1;
            this.clear();
          });
      }
    },

    validateAccess() {
      this.loading_token = true;

      let formData2 = new FormData();
      formData2.set("token_test", this.access_token);

      this.$store
        .dispatch("setAccess", formData2)
        .then(res => {
          Bus.$emit("setAccess", res);
          this.el = 2;
          this.loading_token = false;
        })
        .catch(err => {
          console.log(err.response);
          this.$toast.error({
            title: "Error",
            message: "Password akses anda salah!"
          });
          this.loading_token = false;
          this.access_token = "";
          this.dialog = false;
        });
    },

    close() {
      this.dialog = false;
      this.el = 1;
      this.access_token = "";
    }
  },

  computed: {
    progress() {
      return Math.min(100, this.id_number.length * 6.25);
    },
    colorProg() {
      return ["error", "warning", "blue"][Math.floor(this.progress / 48)];
    }
  }
};
</script>